import React from "react";

const style = `@keyframes dl-spin { to { transform: rotate(360deg); } }`;

export const DefaultLoader = ({text}) => (
    <>
        <style>{style}</style>
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "48px 24px", gap: "14px"}}>
            <div style={{
                width: "36px", height: "36px",
                border: "3px solid #e2e8f0",
                borderTopColor: "#2563eb",
                borderRadius: "50%",
                animation: "dl-spin 0.7s linear infinite",
            }}/>
            {text && <p style={{margin: 0, fontSize: "13px", color: "#94a3b8", fontWeight: 500}}>{text}</p>}
        </div>
    </>
);
